// MultiItemRenderer.js
import React from "react";
import PublishIndicator from "sulu-admin-bundle/components/PublishIndicator";
import MultiItemSelection1 from "../../components/MultiSelection/override/MultiSelection";
import multiSelectionStyles from "../CustomStyle.scss";

const MultiItemRenderer = ({
    item,
    index,
    isDisabled,
    itemColumnClass,
    displayProperties,
    columns,
    inputField,
    additionalParams,
    data,
    openPassportModalHandler,
    handleSwapClick,
    handleItemClick,
    handleSubmitCost,
    listGridColumns,
    component,
    dataPath,
    translate,
    customColumns,
    allItems,
    swapPlayer,
    positions,
    selectedPositions,
}) => {
    const { published = undefined, publishedState = undefined } = item;
    const limit = data.numberOfStartingPlayers;

    let disable = "";

    if (swapPlayer?.id) {
        disable =
            item.isStartingPlayer == swapPlayer?.isStartingPlayer &&
            item.id !== swapPlayer.id
                ? "starting"
                : "";
    }

    const isSelected = swapPlayer?.id === item.id;

    return (
        <MultiItemSelection1.Item
            disabled={false}
            id={item.id}
            index={index + 1}
            key={item.id}
            value={item}
            additionalClass={
                dataPath === "/playersAway" || dataPath === "/playersHome"
                    ? limit
                    : false
            }
        >
            <div
                className={`${multiSelectionStyles.itemContainer} ${
                    multiSelectionStyles[disable]
                }  ${isSelected ? multiSelectionStyles.shake : ""}`}
                style={{
                    width:
                        component === "dhbplayer_match_report" ||
                        component === "dhbstaff_match_report"
                            ? "100%"
                            : "80%",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                {(publishedState !== undefined || published !== undefined) &&
                    !(publishedState && published) && (
                        <div className={multiSelectionStyles.publishIndicator}>
                            <PublishIndicator
                                draft={!publishedState}
                                published={!!published}
                            />
                        </div>
                    )}

                <div
                    className={`${multiSelectionStyles.columnList} js-row-parent`}
                    style={{
                        display: "grid",
                        gridTemplateColumns: listGridColumns,
                    }}
                >
                    {displayProperties.map((displayProperty) => {
                        return customColumns(
                            item,
                            itemColumnClass,
                            handleItemClick,
                            displayProperty,
                            columns,
                            inputField,
                            additionalParams,
                            data,
                            openPassportModalHandler,
                            index,
                            positions,
                            isDisabled,
                            ...(dataPath === "/playersAway" ||
                            dataPath === "/playersHome"
                                ? [handleSwapClick]
                                : ""),
                            ...(dataPath === "/playersAway" ||
                            dataPath === "/playersHome"
                                ? [selectedPositions]
                                : ""),
                            ...(dataPath === "/playersAway" ||
                            dataPath === "/playersHome"
                                ? [swapPlayer]
                                : ""),
                            ...(dataPath === "/coreSquad"
                                ? ["black"]
                                : dataPath === "/squad"
                                ? ["white"]
                                : ""),
                            ...(component === "dhbumpire_costs"
                                ? [handleSubmitCost]
                                : ""),
                            translate
                        );
                    })}
                </div>
            </div>
        </MultiItemSelection1.Item>
    );
};

export default MultiItemRenderer;
